import { Education, RemoveEducationDocument } from '@/types/graphql/types'
import { getErrorMessage } from '@/util/getErrorMessage'
import { useMutation } from '@apollo/client'
import { ActionIcon, Loader, Text, useMantineTheme } from '@mantine/core'
import { useModals } from '@mantine/modals'
import { showNotification } from '@mantine/notifications'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { parseInt } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { MdDeleteOutline } from 'react-icons/md'
import { Edit } from 'tabler-icons-react'
import EducationForm from './EducationForm'
import useEducationItem from '@/hooks/Dashoboard/Members/Profile/Education/useEducationItem'

const EducationItem = ({
  education,
  handleUpdateEducations,
}: {
  education: Education
  handleUpdateEducations: ({
    newEducations,
  }: {
    newEducations: Education[]
  }) => void
}) => {
  const { colorScheme } = useMantineTheme()
  const isDark = colorScheme === 'dark'
  const { openEducationForm, openDeleteMessage, loading } = useEducationItem({
    education,
    handleUpdateEducations,
  })

  return (
    <div
      className={classNames(
        'border rounded-lg p-3 my-3 border-opacity-20 w-full flex',
        isDark ? 'border-gray-200' : 'border-gray-900',
      )}
    >
      <div className="flex-auto">
        <Text size="lg" weight="bold">
          {education.university}
        </Text>
        <Text>
          {education.profession?.titleEn} -{' '}
          {dayjs(education.graduationYear).format('MM/YYYY')}
        </Text>
        <Text size="sm" weight="lighter">
          {education.profession?.titleEn} - {education.specialty?.titleEn} -{' '}
          {education.qualification?.title}
        </Text>
      </div>
      <div>
        <ActionIcon
          variant="default"
          onClick={() => openEducationForm(education)}
          mb={5}
        >
          <Edit size={16} />
        </ActionIcon>
        <ActionIcon
          variant="default"
          onClick={() => openDeleteMessage(education.id)}
        >
          {loading ? <Loader size="xs" /> : <MdDeleteOutline size={16} />}
        </ActionIcon>
      </div>
    </div>
  )
}

export default EducationItem
